import {RecordForm} from '../forms/RecordForm';


import {useStep} from '../hooks/useStep.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate, useParams} from "react-router-dom";
import {Step} from "../types.ts";


export const AddPage = () => {

    const navigate = useNavigate();
    const {id: playbookId, phaseId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId (from route param :id) is required to create a step');
    }

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId (from route param :phaseId) is required to create a step');
    }

    const onCancel = () => {
        navigate(`/playbooks/${playbookId}/phases/${phaseId}`);
    }

    const {
        record,
        createRecord,
    } = useStep();

    // Seed phaseId and playbookId from the route so the mutation input is
    // complete. Mirrors the AddFormDrawer behaviour for consistency.
    const seededRecord = {
        ...(record ?? {}),
        playbookId,
        phaseId,
        position: 0,
    } as Step;

    const handleSubmit = async (values: Step) => {
        await createRecord(values);
        navigate(`/playbooks/${playbookId}/phases/${phaseId}`);
    };

    return (
        <FormPageLayout
            title='Add Step'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={seededRecord} handleSubmit={handleSubmit} handleCancel={onCancel}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
